<template>
  <div class="p20 bg-white main">
    <div class="mt20 mb20">
      <span class="title1">待出库区</span>
    </div>
    <div v-if="show_success" class="success ml100">
      <h2 class="mt100 f26 ">出库单创建成功！出库单号为：{{out_code}}</h2>
      <div class="mt50">
        <router-link to="/prep/stock" class="ivu-btn ivu-btn-primary ml100" tag="span">返回库存</router-link>
        <router-link to="/prep/out" class="ivu-btn ivu-btn-primary ml50" tag="span">前往出库单列表</router-link>
      </div>
    </div>
    <div v-else class="bg-gray p20">
      <div class="mt20 mb20">
        子账户编号: &nbsp;&nbsp;{{client_name_code}}
      </div>
      <div class="table-box">
        <table>
          <tr>
            <th width="10%">SKU</th>
            <th width="10%">ASIN</th>
            <th width="10%">商品名称</th>
            <th width="10%">在库数量</th>
            <th width="10%">可出库数量</th>
            <th width="10%">已选择出库数量</th>
            <th width="20%">操作</th>
          </tr>
          <tr v-if="!list.length">
            <td colspan="6">暂无数据</td>
          </tr>
          <tr v-else v-for="(item,index) in list">
            <td>{{item.sku}}</td>
            <td>
              {{item.product_sku}}
            </td>
            <td>
              {{item.stock_product_name}}
            </td>
            <td>
              {{item.instock_count || 0}}
            </td>
            <td>
              {{item.instock_onshelf_count || 0}}
            </td>
            <td>
              <input @blur="updateCount(item, 3)" v-model="item.out_count" class="w100 ivu-input ivu-input-default"
                placeholder="可选择出库数量">
              <span>
                <Icon @click="updateCount(item, 1)" type="ios-arrow-up" />
                <Icon @click="updateCount(item, 2)" type="ios-arrow-down" />
              </span>
            </td>
            <td>
              <a class="blue" @click="remove(item)">移除待出库区</a>
              <a @click="seeSku(item)" v-show="item.new_sku" class="ml10 blue">查看新SKU标签</a>
            </td>
          </tr>

        </table>
      </div>
      <Paging :page-data="page_data" v-on:setPage="setPage" :selectSize="true" @setSize="chooseSize"></Paging>
      <div class="fr mt30">
        <button class="ivu-btn ivu-btn-primary" @click="createOut">创建出库单</button>
      </div>
    </div>

    <Modal v-model="show_sku" width="400">
      <div class="sku-sign p10 f14">
        <img width="240" height="80" :src="bar_code" />
        <p>{{sku.product_name}}</p>
        <p>New</p>
      </div>

      <div slot="footer" class="tc">
        <button class="ivu-btn ivu-btn-primary" @click="show_sku=false">关闭</button>
      </div>
    </Modal>
  </div>
</template>

<script>
  import Paging from '@/components/common/paging'
  export default {
    components: {
      Paging
    },
    data() {
      return {
        show_success: false,
        list: [],
        client_name_code: '',
        screen_data: {
          client_code: '',
          warehouse_id: '',
          pageNum: 1,
          pageSize: 10,
        },
        page_data: { //分页数据
          pageTotal: 0, //总页数
          dataTotal: 0, //总条数
          pageIndex: 1, //当前页数
          pageCount: 8 //页面最多显示几个分页组
        },
        bar_code: '', //条形码
        sku: {}, //sku
        show_sku: false,
        out_code:'',//出库单号
      }
    },
    methods: {
      /*
       * 分页
       */
      setPage(page) {
        this.screen_data.pageNum = this.page_data.pageIndex = page;
        this.getList();
      },
      chooseSize(size) {
        this.page_data.pageSize = this.screen_data.pageSize = size;
        let p = Math.ceil(this.page_data.dataTotal / this.page_data.pageSize);
        if (this.page_data.pageIndex > p) {
          this.page_data.pageIndex = this.screen_data.pageNum = p;
        }
        this.getList();
      },
      /*
       * 获取列表
       */
      getList() {
        if (!this.screen_data.client_code) {
          this.list = []
          return false;
        }
        this.$axios.get("/WarehouseStock/out/pending", {
          params: this.screen_data
        }).then(res => {
          this.loading = false;
          if (res.success && res.data && res.data.length) {
            this.list = res.data;
          } else {
            this.list = []
          }
          this.page_data.pageTotal = res.pageTotal;
          this.page_data.dataTotal = res.totalSize;
        })
      },
      remove(item) { //移除待出库区
        this.$axios.delete("/WarehouseStock/out/pending", {
          params: {
            client_code: item.client_code,
            sku: item.sku,
            warehouse_id: this.screen_data.warehouse_id,
          }
        }).then(res => {
          if (res.success) {
            this.$Message.success('移除成功');
            this.getList()
          }
        })
      },
      updateCount(item, type) { //更新数量 type=1 加，2 减 ，3是直接修改数量
        let out_count = item.out_count
        if (type == 1) {
          out_count = item.out_count + 1
        } else if (type == 2) {
          out_count = item.out_count - 1
        }
        if (out_count < 1) {
          this.$Message.info('出库数量有误');
          return false
        }
        this.$axios.put("/WarehouseStock/out/pending/out_count", this.$qs.stringify({
          client_code: item.client_code,
          sku: item.sku,
          warehouse_id: this.screen_data.warehouse_id,
          out_count: out_count
        })).then(res => {
          if (res.success) {
            this.$Message.success('更新成功');
            this.getList()
          }
        })
      },
      updateNewsku(item) { //更新新sku
        if (!item.new_sku) {
          return false
        }
        this.$axios.put("/WarehouseStock/out/pending/new_sku", this.$qs.stringify({
          client_code: item.client_code,
          sku: item.sku,
          new_sku: item.new_sku,
          warehouse_id: this.screen_data.warehouse_id,
        })).then(res => {
          if (res.success) {
            this.$Message.success('更新成功');
            this.getList()
          }
        })
      },
      updateProduct(item) { //更新商品名称
        if (!item.product_name) {
          return false
        }
        this.$axios.put("/WarehouseStock/out/pending/product_name", this.$qs.stringify({
          client_code: item.client_code,
          sku: item.sku,
          product_name: item.product_name,
          warehouse_id: this.screen_data.warehouse_id,
        })).then(res => {
          if (res.success) {
            this.$Message.success('更新成功');
            this.getList()
          }
        })
      },
      getCodeImg(code) { //获取条形码
        return new Promise((reslove, reject) => {
          this.$axios
            .get("/common/bar_code/image?code=" + code + "&height=8&width=0.2&hideText=false&withQuietZone=true")
            .then(res => {
              reslove(res); //res.data
            });
        });
      },
      seeSku(item) {
        this.sku = { ...item
        };
        let product_name = item.product_name;
        if (product_name.length > 30) {
          product_name = product_name.substring(0, 13) + ' *** ' + product_name.substring(product_name.length - 13,
            product_name.length)
        }
        this.sku.product_name = product_name;
        this.getCodeImg(item.new_sku).then(res => {
          if (res.success && res.data) {
            this.bar_code = res.data;
            this.show_sku = true
          }
        })
      },
      createOut() { //创建出库单
        this.$axios.post("/WarehouseOut/bill/pending/confirm" ,this.$qs.stringify({
          client_code : localStorage.getItem('client_code'),
          warehouse_id: localStorage.getItem('warehouse_id')
        }))
          .then(res => {
            if(res.success){
              this.out_code = res.data
              this.show_success = true
            }
          });
      }
    },
    created() {
      this.client_name_code = localStorage.getItem('client_name_code') || ''
      this.screen_data.client_code = localStorage.getItem('client_code') || ''
      this.screen_data.warehouse_id = localStorage.getItem('warehouse_id') || ''
      if (!this.screen_data.warehouse_id) {
        this.$Message.info('请选择仓库');
        return false
      }
      if (!this.screen_data.client_code) {
        this.$Message.info('请选择子账户');
        return false
      }
      this.getList()
    }
  }
</script>

<style>
  .table-box tr,
  .table-box th {
    text-align: center;
  }

  .sku-sign {
    width: 260px;
    height: 140px;
    border: 1px solid #ccc;
    margin: auto;
  }

  .sku-modal .ivu-modal-footer {
    height: 70px;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/pages/prep/stock/wait.out.vue